import {Translations} from '@/types';

export type State = Translations

export const state: State = {
    applyFilterLabel: "",
    closeFilterLabel: "",
    openFilterLabel: "",
};
